export default {
  TIPO_NAO_ESPECIFICADO: '?',
  TIPO_DEPARTAMENTO: 'A',
  TIPO_GESTAO: 'B',
  TIPO_RAMOATIVIDADE: 'C',
  TIPO_INVESTIMENTO: 'D'
}
